export const dateValidationPattern =
  /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(1\d{3}|[2-9]\d{3})$/;

export const emailValidationPattern =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/i;

export const nameValidationPattern =
  /^[A-Za-zäöüßÄÖÜáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸ ]+$/;

export const checkMobile =
  /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
